/**
 * 离线同步队列启动器：在 App 启动时尝试 flush 一次同步队列。
 * 真实联网检测由 worker 提供的事件总线驱动；这里只做 best-effort 启动。
 */

import { useEffect } from 'react';
import { process as processSyncQueue } from '../lib/sync/queue';

export const SyncBootstrap: React.FC = () => {
  useEffect(() => {
    let cancelled = false;
    void processSyncQueue().catch(() => {
      // 网络层失败不影响 UI，本地保留，状态机下一次再试
    });
    const handleOnline = () => {
      if (!cancelled) {
        void processSyncQueue();
      }
    };
    window.addEventListener('online', handleOnline);
    return () => {
      cancelled = true;
      window.removeEventListener('online', handleOnline);
    };
  }, []);
  return null;
};
